<template>
  <div>
    <PaperUpload />
  </div>
</template>

<script>
import firebase from 'firebase/app';
import PaperUpload from '@/components/PaperUpload'
import LoginComponent from '@/components/LoginComponent'

export default {
  components: {
    PaperUpload,
    LoginComponent
  },
  mounted() {
    if (firebase.auth().currentUser === null) {
      this.$router.push({ path: '/login', query: { ref: 'upload' }})
    }
  }
}
</script>